export const T = {
  night: "#0A1F3D", royal: "#1263B0", white: "#fff", bg: "#F7F9FC",
  border: "#E2E8F0", muted: "#64748B", red: "#B91C1C",
};
export const panelStyle = { background: T.white, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, marginBottom: 16 };
